'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var _typeof = _interopDefault(require('@babel/runtime/helpers/typeof'));

var DEFAULT_REM = 16;
var useRem = (function () {
  if ((typeof document === "undefined" ? "undefined" : _typeof(document)) !== 'object' || !document.documentElement) {
    return DEFAULT_REM;
  }
  var _React$useRef = React.useRef(window.getComputedStyle(document.documentElement)),
    css = _React$useRef.current;
  var fontSizeParsed = parseInt((css.fontSize || '').replace('px', ''), 10);
  return Number.isNaN(fontSizeParsed) ? DEFAULT_REM : fontSizeParsed;
});

exports.DEFAULT_REM = DEFAULT_REM;
exports.default = useRem;
